import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store";
import { loadStoredSession } from "./store/authSlice";
import AppRouter from "./routes/AppRouter";
import { ThemeProvider } from "./components/theme-provider";
import "./index.css";

store.dispatch(loadStoredSession());

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider storageKey="vite-ui-theme">
        <AppRouter />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);
